export const QUERY = 'QUERY'